import { useContext } from 'react';

import { NotificationsContext } from '../components/NotificationsProvider';

export const useNotifications = () => useContext(NotificationsContext);
